import { SubgraphType } from 'config/subgraph'
import { useSubgraphConfig } from 'hooks/useSubgraphConfig'
import { TransactionType } from 'types/analytics'
import { Transaction } from 'types/analytics'

import type { GetV3PoolTransactionsQuery } from '../../queries/analytics/v3/generated'
import { useGetV3PoolTransactionsQuery } from '../../queries/analytics/v3/generated'

type TransactionsResponse = GetV3PoolTransactionsQuery

export const processV3PoolTransactions = (txs: TransactionsResponse): Transaction[] => {
  const mapTransaction = (tx: any, type: TransactionType, sender: string): Transaction => ({
    type,
    hash: tx.transaction.id,
    timestamp: tx.timestamp,
    sender,
    token0: {
      symbol: tx.pool.token0.symbol,
      address: tx.pool.token0.id,
      amount: parseFloat(tx.amount0),
    },
    token1: {
      symbol: tx.pool.token1.symbol,
      address: tx.pool.token1.id,
      amount: parseFloat(tx.amount1),
    },
    amountUSD: parseFloat(tx.amountUSD),
  })

  const mints = (txs.mints ?? []).map((m) => mapTransaction(m, TransactionType.MINT, m.origin))

  const burns = (txs.burns ?? []).map((b) => mapTransaction(b, TransactionType.BURN, b.owner))

  const swaps = (txs.swaps ?? []).map((s) => mapTransaction(s, TransactionType.SWAP, s.origin))

  return [...mints, ...burns, ...swaps].sort((a, b) => Number(b.timestamp) - Number(a.timestamp))
}

type UseV3PoolTransactionsOptions = {
  enabled?: boolean
}

export const useV3PoolTransactions = (poolAddress: string, options?: UseV3PoolTransactionsOptions) => {
  const subgraphConfig = useSubgraphConfig(SubgraphType.V3)
  const endpoint = subgraphConfig.endpoint
  const normalizedAddress = poolAddress.toLowerCase()

  const {
    data = [],
    isLoading,
    error,
  } = useGetV3PoolTransactionsQuery(
    {
      endpoint,
    },
    {
      address: normalizedAddress,
    },
    {
      ...options,
      select: (data) => processV3PoolTransactions(data),
    }
  )

  return {
    data,
    isLoading,
    error,
  }
}
